export enum RebootStatus {
  Reboot = 'user',
  Boot = 'boot'
};
